import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const fetchAllHoliday = createAsyncThunk(
  "getAllHolidayData/fetchAllHoliday",
  async (year, { rejectWithValue }) => {
    try {
      // Use Math.max to ensure we never go below 0
      const url = `${api.holidays.getAllHoliday}${year}`;
      //console.log("url", url);
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to connect to server",
      );
    }
  },
);

export const createHoliday = createAsyncThunk(
  "holiday/createHoliday",
  async (payload, { rejectWithValue }) => {
    try {
      const url = `${api.holidays.createHoliday}`;
      const response = await axiosPrivate.post(url, payload);
      console.log("createHolidayresponse", response)
      if (response.data.success === true) {
        toast.success(response.data.reason, { className: "toast-success-custom", });
      } else {
        toast.error(response.data.reason, { className: "toast-error-custom", });
      }
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to connect to server",
      );
    }
  },
);

export const publishHoliday = createAsyncThunk(
  "holiday/publishHoliday",
  async (year, { rejectWithValue }) => {
    try {
      const url = `${api.holidays.publishHoliday}${year}`;
      const response = await axiosPrivate.post(
        url,
        {},
        {
          headers: { "Content-Type": "application/json" },
        },
      );
      if (response.data.success === true) {
        toast.success(response.data.reason, { className: "toast-success-custom", });
      } else {
        toast.error(response.data.reason, { className: "toast-error-custom", });
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to publish holidays",
      );
    }
  },
);

export const updateHoliday = createAsyncThunk(
  "holiday/updateHoliday",
  async ({ id, holidayData }, { rejectWithValue }) => {
    try {
      const url = `${api.holidays.updateHoliday}${id}`;
      const response = await axiosPrivate.put(url, holidayData, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.data.success === true) {
        toast.success(response.data.reason, { className: "toast-success-custom", });
      } else {
        toast.error(response.data.reason, { className: "toast-error-custom", });
      }
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to update holiday",
      );
    }
  },
);

export const HRViewHoliday = createAsyncThunk(
  "holiday/HRViewHoliday",
  async (holidayYear, { rejectWithValue }) => {
    try {
      const url = `${api.holidays.HRViewHoliday}${holidayYear}`;
      //console.log("url", url);
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to connect to server",
      );
    }
  },
);

export const deleteHoliday = createAsyncThunk(
  "holiday/deleteHoliday",
  async (holidayId, { rejectWithValue }) => {
    try {
      const url = `${api.holidays.deleteHoliday}${holidayId}`;
      const response = await axiosPrivate.delete(url);
      if (response.data.success === true) {
        toast.success(response.data.reason, { className: "toast-success-custom", });
      } else {
        toast.error(response.data.reason, { className: "toast-error-custom", });
      }
      return holidayId;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to delete holiday",
      );
    }
  },
);

export const getHolidayById = createAsyncThunk(
  "holiday/getHolidayById",
  async (id, { rejectWithValue }) => {
    try {
      const url = `${api.holidays.getHolidayById}${id}`;
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to fetch holiday",
      );
    }
  },
);

export const listOfCalendar = createAsyncThunk(
  "holiday/getListOfCalendar",
  async (year, { rejectWithValue }) => {
    try {
      const url = `${api.holidays.getListOfCalendar}`;
      //console.log("getListOfCalendar======================", url);
      const response = await axiosPrivate.get(url);
      //console.log('response===========', response);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "--Unable to connect to server--",
      );
    }
  },
);


const getAllHolidaySlice = createSlice({
  name: "holidays",
  initialState: {
    allHolidays: [],
    calendarList: [],
    status: "idle",
    loading: false,
    error: null,
    selectedHoliday: null,
    HRViewHoliday: [],
    selectedEditYear: null,
  },
  reducers: {
    setSelectedEditYear: (state, action) => {
      state.selectedEditYear = action.payload;
    },
    clearSelectedEditYear: (state) => {
      state.selectedEditYear = null;
    },
  },
  extraReducers: (builders) => {
    builders
      .addCase(fetchAllHoliday.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllHoliday.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.allHolidays = action.payload;
      })
      .addCase(fetchAllHoliday.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createHoliday.pending, (state) => {
        state.createStatus = "loading";
        state.createLoading = true;
        state.createError = null;
      })
      .addCase(createHoliday.fulfilled, (state, action) => {
        state.createStatus = "succeeded";
        state.createLoading = false;

        state.allHolidays.push(action.payload);
      })
      .addCase(createHoliday.rejected, (state, action) => {
        state.createStatus = "failed";
        state.createLoading = false;
        state.createError = action.payload;
      })

      .addCase(updateHoliday.pending, (state) => {
        state.updateStatus = "loading";
        state.updateLoading = true;
        state.updateError = null;
      })
      .addCase(updateHoliday.fulfilled, (state, action) => {
        state.updateStatus = "succeeded";
        state.updateLoading = false;
        const updatedHoliday = action.payload;
        state.allHolidays = state.allHolidays.map((holiday) =>
          holiday.id === updatedHoliday.id ? updatedHoliday : holiday,
        );
      })
      .addCase(updateHoliday.rejected, (state, action) => {
        state.updateStatus = "failed";
        state.updateLoading = false;
        state.updateError = action.payload;
      })

      .addCase(deleteHoliday.pending, (state) => {
        state.deleteStatus = "loading";
        state.deleteLoading = true;
        state.deleteError = null;
      })
      .addCase(deleteHoliday.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.deleteLoading = false;
        state.allHolidays = state.allHolidays.filter(
          (holiday) => holiday.id !== action.payload,
        );
      })
      .addCase(deleteHoliday.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.deleteLoading = false;
        state.deleteError = action.payload;
      })

      .addCase(HRViewHoliday.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(HRViewHoliday.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.HRViewHoliday = action.payload;
        // state.holidayYearData[action.meta.arg] = action.payload;
      })
      .addCase(HRViewHoliday.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getHolidayById.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(getHolidayById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.selectedHoliday = action.payload;
      })
      .addCase(getHolidayById.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(listOfCalendar.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listOfCalendar.fulfilled, (state, action) => {
        state.loading = false;
        state.calendarList = action.payload;
      })
      .addCase(listOfCalendar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setSelectedEditYear,
  clearSelectedEditYear,
} = getAllHolidaySlice.actions;

export default getAllHolidaySlice.reducer;
